export const MaxViewNameLength = 40;

export enum ViewTypes {
  list = 'list',
}
